import { LayoutControls } from "@/appComponents/Navigation/RightSidebar/BackgroundDisplay/LayoutControls";

export const DragLayoutSegment = props => {
  const { layout } = props;
  return <LayoutControls editing={false} onChange={() => undefined} value={layout} />;
};
